
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function NewRequestPage() {
  const [formData, setFormData] = useState({
    location: '',
    notes: '',
    contactPerson: '',
    phone: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.location) return;

    setIsSubmitting(true);
    
    // محاكاة إرسال الطلب
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccess(true);
      
      // العودة للصفحة الرئيسية بعد 2 ثانية
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }, 1500);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleMapLocation = () => {
    setShowMapModal(true);
  };

  const selectLocation = (address: string) => {
    setFormData(prev => ({
      ...prev,
      location: address
    }));
    setShowMapModal(false);
  };

  if (showSuccess) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" dir="rtl">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center max-w-sm w-full">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-check-line text-green-500 text-3xl"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">تم إرسال الطلب بنجاح</h2>
          <p className="text-gray-600 mb-4">سيتم التواصل معك قريباً من قبل السائق</p>
          <div className="animate-pulse text-sm text-gray-500">جاري العودة للصفحة الرئيسية...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-4 fixed w-full top-0 z-10">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center ml-3 hover:bg-white/30 transition-colors"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          <div>
            <h1 className="font-bold text-lg">طلب حاوية جديدة</h1>
            <p className="text-sm opacity-90">املأ البيانات المطلوبة</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 pb-6 px-4">
        {/* Service Info */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <div className="flex items-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center ml-4">
              <i className="ri-add-box-line text-white text-2xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-gray-800 text-lg">طلب حاوية جديدة</h2>
              <p className="text-gray-600 text-sm">سيتم توصيل حاوية جديدة للموقع المحدد</p>
            </div>
          </div>
          
          <img 
            src="https://public.readdy.ai/ai/img_res/d3a183d43014cb399bf35a70f3d187c3.jpg"
            alt="خدمة توصيل الحاويات"
            className="w-full h-32 object-cover rounded-lg"
          />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Location */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-map-pin-line ml-2"></i>
              الموقع *
            </label>
            <textarea
              value={formData.location}
              onChange={(e) => handleInputChange('location', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right resize-none"
              rows={3}
              placeholder="أدخل العنوان التفصيلي للموقع..."
              required
            />
            <button
              type="button"
              onClick={handleMapLocation}
              className="mt-3 flex items-center text-blue-500 hover:text-blue-600 text-sm"
            >
              <i className="ri-map-line ml-2"></i>
              تحديد الموقع على الخريطة
            </button>
          </div>

          {/* Contact Person */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-user-line ml-2"></i>
              اسم الشخص المسؤول
            </label>
            <input
              type="text"
              value={formData.contactPerson}
              onChange={(e) => handleInputChange('contactPerson', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right"
              placeholder="اسم الشخص المسؤول عن استلام الحاوية"
            />
          </div>

          {/* Phone */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-phone-line ml-2"></i>
              رقم الهاتف
            </label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right"
              placeholder="رقم الهاتف للتواصل"
            />
          </div>

          {/* Notes */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <label className="block text-sm font-medium text-gray-700 mb-3 text-right">
              <i className="ri-file-text-line ml-2"></i>
              ملاحظات إضافية
            </label>
            <textarea
              value={formData.notes}
              onChange={(e) => handleInputChange('notes', e.target.value)}
              className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-right resize-none"
              rows={3}
              placeholder="أي ملاحظات أو تعليمات خاصة..."
              maxLength={500}
            />
            <div className="text-xs text-gray-500 mt-2 text-right">
              {formData.notes.length}/500
            </div>
          </div>

          {/* Submit Button */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <button
              type="submit"
              disabled={isSubmitting || !formData.location}
              className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 rounded-lg font-medium hover:from-orange-600 hover:to-orange-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white ml-2"></div>
                  جاري إرسال الطلب...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-line ml-2"></i>
                  إرسال الطلب
                </>
              )}
            </button>
            
            {!formData.location && (
              <p className="text-red-500 text-sm mt-2 text-center">الموقع مطلوب</p>
            )}
          </div>
        </form>
      </div>

      {/* Map Modal */}
      {showMapModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full max-h-[80vh] overflow-hidden">
            <div className="p-4 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-gray-800">تحديد الموقع</h3>
                <button
                  onClick={() => setShowMapModal(false)}
                  className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors"
                >
                  <i className="ri-close-line text-gray-600"></i>
                </button>
              </div>
            </div>
            
            <div className="p-4">
              <div className="mb-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.0!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1234567890"
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  className="rounded-lg"
                ></iframe>
              </div>
              
              <div className="space-y-3">
                <h4 className="font-medium text-gray-800 text-right">اختر موقعاً:</h4>
                
                <button
                  onClick={() => selectLocation('الرياض، حي الملز، شارع الأمير محمد بن عبدالعزيز')}
                  className="w-full p-3 text-right bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-blue-500 ml-3"></i>
                    <div>
                      <div className="font-medium text-gray-800">الرياض، حي الملز</div>
                      <div className="text-sm text-gray-600">شارع الأمير محمد بن عبدالعزيز</div>
                    </div>
                  </div>
                </button>
                
                <button
                  onClick={() => selectLocation('الرياض، حي العليا، طريق الملك فهد')}
                  className="w-full p-3 text-right bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-blue-500 ml-3"></i>
                    <div>
                      <div className="font-medium text-gray-800">الرياض، حي العليا</div>
                      <div className="text-sm text-gray-600">طريق الملك فهد</div>
                    </div>
                  </div>
                </button>
                
                <button
                  onClick={() => selectLocation('الرياض، حي النخيل، شارع التخصصي')}
                  className="w-full p-3 text-right bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-blue-500 ml-3"></i>
                    <div>
                      <div className="font-medium text-gray-800">الرياض، حي النخيل</div>
                      <div className="text-sm text-gray-600">شارع التخصصي</div>
                    </div>
                  </div>
                </button>
              </div>
              
              <button
                onClick={() => setShowMapModal(false)}
                className="w-full mt-4 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300 transition-colors"
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}